define('shared/my/accessToken',[
    './accessToken/get',
    './accessToken/set'
], function (get, set) {
    return {
        get: get,
        set: set
    };
});
